import React from 'react';
import Swiper from '@/pages/intelligence/components/Swiper';
import { Modal } from 'tea-component';
import './index.scss';
const swiperParams: any = {
  showArrows: true,
  showIndicators: false,
  infiniteLoop: true,
  autoPlay: false,
  emulateTouch: true,
  showStatus: false,
};
const ImagePreview = (props: any) => {
  const { visible, onClose, imageList = [] } = props;
  return (
    <Modal
      size={'auto'}
      visible={visible}
      className={'dbi-public-true-data-image-preview'}
      onClose={onClose}
      maskClosable
    >
      <Swiper height={660} urlList={imageList} params={swiperParams} noDataTip={''} />
    </Modal>
  );
};
export default ImagePreview;
